<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
            <TableActionHeader 
                v-on:filterChange="onFilterChange" 
                v-on:newItem="onNewItem"
                :newButton="$UIPrivilegeCreate('timetables', 'lines')">
            </TableActionHeader> 
            <LineTable :filter="filter" v-on:selectItem="onSelectItem"></LineTable>               
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="formType == ''"></InfoCard>
        <card v-if="formType == 'new'">
          <CardHeader :title="$t('item.new')" />
          <LineForm :item="item" :action="formType"></LineForm>                  
        </card>
        <card v-if="formType == 'edit'">
          <CardHeader :title="item ? item.nimi : ''" type="item" />
          <LineForm :item="item" :action="formType"></LineForm>                  
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import LineTable from '@/components/Timetable/LineTable.vue'
import LineForm from '@/components/Timetable/LineForm.vue'
import i18n from '@/i18n'

export default {
    name: 'Lines',
    components: {
        LineTable, LineForm, TableActionHeader, CardHeader
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            item: {
                "tunnus": null,
                "nimi": null,
                "organisaatio": null
            },
            formType: ""
        }
    },
    methods: {
        showEditor: function(show, type) {
            this.showForm = show;
            this.formType = type;
            this.cols = this.showForm ? 8 : 12;
        },
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = {};        
            this.showEditor(true, "new");
        },
        onSelectItem: function(item) {            
            this.item = JSON.parse(JSON.stringify(item));           
            this.showEditor(true, "edit");
        },
        onClose(){
            this.showEditor(false, "");
        },
    },
    computed: {
        formTitle(){
            return i18n.t('item.' + this.formType);
        }
    }
}
</script>